import React from "react";
import { TABLES } from "../../Utils/tableConst"
import { Table } from "../Table"

export const TableQuery6 = () => (
    <Table tableData={TABLES.QUERY_6} theme="horizontal" />
);
